import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InferenceService {

  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  updateModels(photo: string, inputBrand: string, imageEmbedding: any[], inputPrice: string,
    inputItem: string, inputMaterial: string, color: string, brandRepresentative: string, brandEmbedding: any[] | string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = {
      photo: photo,
      brand: inputBrand,
      image_embedding: imageEmbedding,
      price: inputPrice,
      item: inputItem,
      material: inputMaterial,
      color: color,
      brand_representative: brandRepresentative,
      brand_embedding: brandEmbedding,
    };
    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<any>(`${this.apiUrl}/update`, body, options);
  }

  isUpdating() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.get<any>(`${this.apiUrl}/is-updating`, options);
  }

  undoUpdate(lastImageId: string, lastBrandId: string, lastClusterId: string, updatesResult: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const options = {
      headers: headers,
      withCredentials: true
    };

    const body = {
      new_image_id: lastImageId,
      new_brand_id: lastBrandId,
      new_cluster: lastClusterId,
      updates_result: updatesResult
    };

    return this.http.post(`${this.apiUrl}/undo-update`, body, options)
  }

  uploadPhotosAndPredictDetails(fullProductPhoto: any, labelPhoto: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = { full_product_photo: fullProductPhoto, label_photo: labelPhoto };
    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<any>(`${this.apiUrl}/predict-dual`, body, options);
  }

  pricingProduct(brand: string, age: string, condition: string, fullProductPhoto: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = { 
      full_product_photo: fullProductPhoto,
      brand: brand,
      age: age,
      condition: condition
    };

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<any>(`${this.apiUrl}/get-price`, body, options);
  }

  updatePriceForProductDual(fullProductPhoto: any, labelPhoto: any, price: number, item: string, material: string, color: string,
    brand: string, brandRepresentative: string, age: string, condition: string
  ) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = { 
      full_product_photo: fullProductPhoto,
      label_photo: labelPhoto,
      price: price,
      item: item,
      material: material,
      color: color,
      brand: brand,
      brand_representative: brandRepresentative,
      age: age,
      condition: condition
    };

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<any>(`${this.apiUrl}/update-models`, body, options);
  }

  uploadPhotosForTraining(fullProductPhoto: any, labelPhoto?: any, priceTagPhoto?: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = { 
      full_product_photo: fullProductPhoto,
      label_photo: labelPhoto,
      price_tag_photo: priceTagPhoto,
    };

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<any>(`${this.apiUrl}/upload-train`, body, options);
  }

  updateForTraining(fullProductPhoto: any, price: number, item: string, material: string, color: string,
      brand: string, age: string, condition: string, labelPhoto?: any, priceTagPhoto?: any
  ) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const body = { 
      full_product_photo: fullProductPhoto,
      label_photo: labelPhoto,
      price_tag_photo: priceTagPhoto,
      price: price,
      item: item,
      material: material,
      color: color,
      brand: brand,
      age: age,
      condition: condition
    };

    const options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<any>(`${this.apiUrl}/update-train`, body, options);
  }

}
